import { useEffect, useState } from 'react'

export function useIsTouchDevice() {
  const [isTouchDevice, setIsTouchDevice] = useState(false)

  useEffect(() => {
    const mediaQuery = window.matchMedia('(hover: none) and (pointer: coarse)')
    setIsTouchDevice(mediaQuery.matches)

    const handleMediaChange = (e: MediaQueryListEvent) => setIsTouchDevice(e.matches)
    mediaQuery.addEventListener('change', handleMediaChange)

    return () => mediaQuery.removeEventListener('change', handleMediaChange)
  }, [])

  return isTouchDevice
}
